(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for daytask-task-states-list
    module.directive('agendaDaytaskStatesFilter', [function () {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/agenda/templates/agenda-daytask-states-filter.template.html',
            controller: 'TaskStatesFilterController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                paginationService: '=', // the overview service holds the data
                isToDo: '@' // type of tasks
            }
        };
        return directive;


    }]);

})();